var CONFIG = {
    projectName: "Marriage License Tracking",
    apiURL: {
        local: "",
        staging: "https://azjeditest01:32772/mls-api/"
    },
    licenseNumberDigitLimit: 7
};

module.exports = { CONFIG };